var { Sidechain } = require("@nprapps/sidechain");
Sidechain.registerGuest();
